import React, { useEffect } from "react";
import { QRCodeSVG } from "qrcode.react";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import Button from "components/Button";
import InfoBox from "components/InfoBox";

import UaHryvniaIcon from "assets/images/ua-hryvnia-icon.svg";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";
import { blogRoutes, blogURL } from "routes/blogRoutes";

import { styles } from "./styles";

interface IbanPaymentUrlQrModalProps {
  isOpen: boolean;
  onCloseModal: () => void;
  clientNotes?: string;
  paymentUrl?: string;
}

const IbanPaymentUrlQrModal: React.FC<IbanPaymentUrlQrModalProps> = (props) => {
  const { isOpen, onCloseModal, clientNotes, paymentUrl } = props;

  useEffect(() => {
    if (isOpen) {
      analytics().sendConversionEvent(
        AnalyticsEvents.iban_qr_show_qr_modal,
        null,
        true,
      );
    }
  }, [isOpen]);

  const onBlogClick = () => {
    analytics().sendConversionEvent(
      AnalyticsEvents.iban_qr_blog_from_payment_click,
      null,
      true,
    );

    window.open(`${blogURL}/${blogRoutes.ibanInvoiceInstruction}`, "_blank");
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onCloseModal}
      slotProps={{ paper: { sx: styles.modal } }}
    >
      <DialogContent sx={styles.content}>
        <Box sx={styles.qrContainer}>
          <Box sx={styles.qrWrapper}>
            <QRCodeSVG
              id={"iban-payment-qr"}
              value={paymentUrl || ""}
              size={160}
              marginSize={0}
              level="Q"
              imageSettings={{
                src: UaHryvniaIcon,
                width: 40,
                height: 40,
                excavate: false,
              }}
            />
          </Box>
        </Box>
        <Typography variant="h5" sx={{ mb: 0.5 }}>
          Оплата за QR-кодом
        </Typography>
        <Typography variant="body1" color="grey700">
          Скануйте QR-код у банківському додатку або камерою телефону, щоб
          здійснити оплату.
        </Typography>
        <Link
          variant="subtitle2"
          sx={{ cursor: "pointer" }}
          color="primary"
          onClick={onBlogClick}
        >
          Дізнатись більше
        </Link>
        {clientNotes && (
          <Box sx={{ mt: 3 }}>
            <InfoBox title="Зверніть увагу!" content={clientNotes} />
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ mt: 3, p: 0 }}>
        <Button
          variant="contained"
          color="secondary"
          onClick={onCloseModal}
          withBorder
        >
          Закрити
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IbanPaymentUrlQrModal;
